module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f7f8fa"
    }
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('repair_title'),
      "url": "/opera/fangT"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "opera-warp"
  }, [_c('div', {
    staticClass: "orderSta clearfix"
  }, [_c('div', {
    staticClass: "Num"
  }, [_vm._v(_vm._s(_vm.orderInfo.rmno) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "sta"
  }, [(_vm.orderInfo.chg_sta == 'S') ? _c('span', {
    staticStyle: {
      "color": "#D0011B"
    }
  }, [_vm._v(_vm._s(_vm.$t('repair_staS')))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.chg_sta == 'O') ? _c('span', {
    staticStyle: {
      "color": "#D0011B"
    }
  }, [_vm._v(_vm._s(_vm.$t('repair_staO')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\r\n            " + _vm._s(_vm.$t('fangTXQ_baseInfo')) + "\r\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent "
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_rmno')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.rmno))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_sta')) + ":\r\n              "), (_vm.orderInfo.chg_sta == 'S') ? _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.$t('repair_staS')))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.chg_sta == 'O') ? _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.$t('repair_staO')))]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('repair_begin')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("datefomate")(_vm.orderInfo.date_begin)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('repair_end')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("datefomate")(_vm.orderInfo.date_end)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\r\n            " + _vm._s(_vm.$t('other')) + "\r\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('reason')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.weixiu_reason))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$t('book_remark')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.remark))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-175403ef","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/repair.vue
// module id = 1739
// module chunks = 107